import { apiClient, type PartnerExEntity } from '@/libs/api'

export const fetchOwnPartner = async (
  tenantKey: string,
  signal?: AbortSignal
): Promise<PartnerExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .partners.own_partner.$get({
      config: {
        signal
      }
    })
  return data
}
